import { DEFAULTS, MatcherCategoryFiltersToLabels } from '@/constants';
import _ from 'lodash';

export const MatcherTaskVersion = {
  V1: 'v1',
  V2: 'v2'
};

export const TaskCreationSteps = {
  CREATE_TASK_FOR_BUSINESS: 'CREATE_TASK_FOR_BUSINESS',
  SELECT_TASK_IMPORT_SESSION: 'SELECT_TASK_IMPORT_SESSION',
  SELECT_TASK_IMPORT_REQUEST: 'SELECT_TASK_IMPORT_REQUEST',
  UPLOAD_TASK_FILES: 'UPLOAD_TASK_FILES',
  TASK_OVERVIEW: 'TASK_OVERVIEW',
  ADVANCED_TASK_OPTIONS: 'ADVANCED_TASK_OPTIONS'
  // MULTI_SITE_SESSION_CONFIGURATION: 'MULTI_SITE_SESSION_CONFIGURATION',
};

export const OrderedTaskCreationSteps = [
  TaskCreationSteps.CREATE_TASK_FOR_BUSINESS,
  TaskCreationSteps.SELECT_TASK_IMPORT_SESSION,
  TaskCreationSteps.SELECT_TASK_IMPORT_REQUEST,
  TaskCreationSteps.UPLOAD_TASK_FILES,
  TaskCreationSteps.TASK_OVERVIEW,
  TaskCreationSteps.ADVANCED_TASK_OPTIONS
];

const { CUSTOM_PARAMETERS } = DEFAULTS.MATCHER;
const DEFAULT_LOCALE = [
  _.get(_.head(CUSTOM_PARAMETERS.LOCALE_OPTIONS), 'value')
];

export const defaultTaskContext = {
  clinic: '',
  officialname: '',
  name: '',
  salesdrop: 'year',
  salesthreshold: 10,
  cutoff: 'firm',
  cutoffmonths: 36,
  pass: _.head(CUSTOM_PARAMETERS.PASSES),
  neversold: _.head(CUSTOM_PARAMETERS.NEVER_SOLDS),
  groupname: '',
  labidmode: _.head(CUSTOM_PARAMETERS.LAB_ID_MODES),
  rxid: null,
  inhousefilter: null,
  inhousesrc: null,
  vendorfilter: null,
  categoryclassification: null,
  cutoffthreshold: 3,
  outputmode: _.head(CUSTOM_PARAMETERS.OUTPUT_MODE),
  updatedsrcfile: null,
  preservevariationnames: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
  preserveprices: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
  omitsizeproperty: _.head(CUSTOM_PARAMETERS.OFF_ON_OPTIONS),
  fullcore: true,
  mergedispensingfees: _.head(CUSTOM_PARAMETERS.MERGE_DISPENSING_FEED_OPTIONS),
  clearminimumprice: _.head(CUSTOM_PARAMETERS.CLEAR_MINIMUM_PRICE_OPTIONS),
  dontclearqoh: _.head(CUSTOM_PARAMETERS.DONT_CLEAR_QOH_OPTIONS),
  ignorepimslabinfo: null,
  locale: DEFAULT_LOCALE,
  mindiagmatch: 0.6,
  diagnosisignorecount: 5,
  useprovidedvariationname: false,
  rematch: []
};

export const defaultTaskOptions = {
  unitSystem: CUSTOM_PARAMETERS.UNIT_SYSTEM[0],
  debug: false,
  type: 'common',
  labMatchingTechnique: 'firm',
  defaultlab: ['idexx'],
  defaultReferenceLab: ['idexx'],
  historicLab: ['idexx', 'abaxis'],
  filters: MatcherCategoryFiltersToLabels.map(({ value }) => value),
  recentResultId: null,
  ..._.cloneDeep(defaultTaskContext)
};

export const defaultTask = {
  name: '',
  business: undefined,
  importSession: undefined,
  importRequest: undefined,
  // Uploads related data
  recentResultId: undefined,
  useRecentResult: false,
  sessionInventoryFilePath: undefined,
  useSessionInventoryFile: undefined,
  selectedInputFile: undefined,
  selectedInputFileFormat: undefined,
  selectedHistoryFile: undefined,
  selectedPreviousRunFile: undefined,
  selectedInventoryFile: undefined,
  taskOptions: _.cloneDeep(defaultTaskOptions)
};
